// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"570":"dfa0218f85653784","723":"cd1d168c13c26687"}[chunkId] + ".js";
};